export class Version {
  version: string;

  constructor(version: string) {
    this.version = version;
  }

  greaterThan(otherVersion: string): boolean {
    return this.version.localeCompare(otherVersion) > 0;
  }

  greaterThanOrEqualTo(otherVersion: string): boolean {
    return this.version.localeCompare(otherVersion) >= 0;
  }

  lessThan(otherVersion: string): boolean {
    return this.version.localeCompare(otherVersion) < 0;
  }

  lessThanOrEqualTo(otherVersion: string): boolean {
    return this.compare(otherVersion) <= 0;
  }

  private compare(otherVersion: string): number {
    return this.version.localeCompare(otherVersion);
  }
}
